import { useEffect, useRef } from 'react';
import { checkForStaleVersion } from '../utils/app-version';

// Binds the re-open triggers (focus/visibilitychange/pageshow); one owner per surface via enabled.
export function useAppVersionWatch(enabled: boolean, onStale: (version: string) => void): void {
  const onStaleRef = useRef(onStale);
  onStaleRef.current = onStale;

  useEffect(() => {
    if (!enabled) return;
    const run = () => {
      void checkForStaleVersion().then((version) => {
        if (version) onStaleRef.current(version);
      });
    };
    const onVisible = () => {
      if (document.visibilityState === 'visible') run();
    };
    window.addEventListener('pageshow', run);
    window.addEventListener('focus', run);
    document.addEventListener('visibilitychange', onVisible);
    run();
    return () => {
      window.removeEventListener('pageshow', run);
      window.removeEventListener('focus', run);
      document.removeEventListener('visibilitychange', onVisible);
    };
  }, [enabled]);
}
